
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'pause': {
    width: 16,
    height: 16,
    viewBox: '0 0 682.98 688.56',
    data: '&quot;<path pid="0" class="cls-1" d="M341.68 667.89c-175.57 0-318.41-142.84-318.41-318.41S166.11 31.07 341.68 31.07s318.41 142.84 318.41 318.41-142.84 318.41-318.41 318.41zm0-596.39c-153.28 0-278 124.7-278 278s124.7 278 278 278 278-124.7 278-278-124.68-278-278-278z"/><path pid="1" class="cls-1" d="M227.4 189.71h74.13v334.41H227.4zM368.92 189.71h74.13v334.41h-74.13z"/>'
  }
})
